__turbopack_context__.v({
  "modalRoot": "NIvM2a_modalRoot",
  "primaryOffersRoot": "NIvM2a_primaryOffersRoot",
  "transitionRoot": "NIvM2a_transitionRoot",
});
